import * as S from '../style';

// import Drawer from '@/components/Dashboard/common/Drawer';
import CommonButton from '@design/components/button/Button';
import FilterGroup from '@/components/exportData/panel/DimensionEditor/FilterGroup';
// import InputField from '@/components/Common/InputField';

// import FilterIcon from '@svgIcons/filter.svg';
import PlusIcon from '@svgIcons/plus.svg';

import {
    // countFilters,
    // countFullFilters,
    getOuterConditions,
} from '@/components/Dashboard/common/Filter/utils';

import {
    DEFAULT_AND_OR_FILTER,
    DEFUALT_OR_CONDITION,
    // DEFUALT_AND_CONDITION,
    // LOGICAL_OPERATOR,
    // DEFAULT_BREAKDOWNLIST_BY_CHANNEL,
    // LOGICAL_OPERATOR,
    OUTER_CONDITIONS_PATH,
    DEFUALT_AND_CONDITION,
} from '@/components/Dashboard/common/Filter/const';

import { FLEX_CENTER_DIV, FLEX_DIV } from '@/styles/common.styled.component';
import { FILTER_KEYS } from '@/utils/consts';
import {
    checkValidFilterField,
    getPrefix,
    makeBreakdownListByCategory,
    makeCategoryListByPrefix,
} from '@/components/Dashboard/common/UaFilterSettingPanel';
// import { refineChannel } from '../WidgetSettingPanel/options/dataSource';

const {
    TITLE,
    STATUS,
    CHANNEL,
    ID,
    AD_ACCOUNT_ID,
    UTM,
    LABEL,
    OS,
    OBJECTIVE,
    GENERIC,
} = FILTER_KEYS;

export default {
    name: 'DimensionTypeEditor',
    props: {
        categoryLocaleMap: {
            type: Object,
            default() {
                return {};
            },
        },
        availableBreakdownList: {
            type: Array,
            default: () => [],
        },
        isMarketing: {
            type: Boolean,
            default: false,
        },
        customFilterList: {
            type: Array | String,
            default: () => DEFAULT_AND_OR_FILTER,
        },
        elseCaseExists: {
            type: Boolean,
            default: false,
        },
        onCancel: {
            type: Function,
        },
    },
    data() {
        return {
            isUpdating: false,
            filterList: this.customFilterList || DEFAULT_AND_OR_FILTER,
            breakdownListByChannel: {},
            categoryListByPrefix: {},
            genericLevelOptions: [],
            elseCasePresent: this.elseCaseExists,
        };
    },
    watch: {
        customFilterList(value) {
            if (!this.isUpdating) {
                this.filterList = value || DEFAULT_AND_OR_FILTER;
            }
        },
    },
    computed: {
        outerConditions() {
            return getOuterConditions(this.filterList);
        },
        selectedCategories() {
            const { outerConditions, categoryListByPrefix } = this;

            return outerConditions.reduce((acc, cur) => {
                const { dataSourceType, field } = R.compose(
                    R.head,
                    R.propOr([{}], 'conditions')
                )(cur);

                if (!dataSourceType || !field) return acc;

                const prefix = getPrefix(field);
                const categories = R.propOr([], prefix, categoryListByPrefix);

                return [...acc, ...categories];
            }, []);
        },
    },
    methods: {
        updateFilterList(value) {
            this.isUpdating = true; // Mark as updating
            this.filterList = value;
            this.$emit('setCode', value);
            this.isUpdating = false;
        },
        close() {
            this.$emit('cancel');
        },
        fetchAvailableBreakdowns() {
            const breakdownListByCategory = R.compose(
                makeBreakdownListByCategory,
                R.filter(checkValidFilterField)
            )(this.availableBreakdownList);
            const categoryListByPrefix = makeCategoryListByPrefix(
                Object.entries(breakdownListByCategory)
            );

            this.categoryListByPrefix = categoryListByPrefix;
            this.breakdownListByChannel = breakdownListByCategory;
            this.genericLevelOptions = Object.keys(breakdownListByCategory);
        },
        handleRemoveAll() {
            const updatedFilters = DEFAULT_AND_OR_FILTER;
            this.elseCasePresent = false;
            this.updateFilterList(updatedFilters);
        },
        handleAddFilterGroup() {
            const { outerConditions } = this;

            const updatedConditions = R.append(
                { ...DEFUALT_OR_CONDITION, customFieldValue: '' },
                outerConditions
            );

            const updatedFilters = R.assocPath(
                OUTER_CONDITIONS_PATH,
                updatedConditions,
                this.filterList
            );

            this.updateFilterList(updatedFilters);
        },
        handleAddFilterGroupElse() {
            this.elseCasePresent = true;

            const { outerConditions } = this;

            const updatedConditions = R.append(
                { ...DEFUALT_OR_CONDITION, isElse: true, customFieldValue: '' },
                outerConditions
            );

            const updatedFilters = R.assocPath(
                OUTER_CONDITIONS_PATH,
                updatedConditions,
                this.filterList
            );

            this.updateFilterList(updatedFilters);
        },
        setElseCasePresent(value) {
            this.elseCasePresent = value;
        },
        genericLevelTranslator(level) {
            const { categoryLocaleMap } = this;

            return R.propOr(level, level, categoryLocaleMap);
        },
    },
    mounted() {
        const { genericAccounts, fetchAvailableBreakdowns } = this;

        fetchAvailableBreakdowns(genericAccounts);
    },
    render() {
        const { breakdownListByChannel, categoryListByPrefix } = this;
        const filterGroups = R.pathOr(
            [DEFUALT_AND_CONDITION],
            OUTER_CONDITIONS_PATH,
            this.filterList
        );

        const filterGroupsDom$ =
            filterGroups.map(({ customFieldValue, conditions }, idx) => {
                const isElseGroup =
                    this.elseCasePresent && idx === filterGroups.length - 1;
                const _discardFieldOptions = this.isMarketing
                    ? [LABEL, STATUS, OS, UTM, GENERIC]
                    : [
                          TITLE,
                          STATUS,
                          CHANNEL,
                          ID,
                          AD_ACCOUNT_ID,
                          UTM,
                          LABEL,
                          OS,
                          OBJECTIVE,
                      ];

                const props = {
                    attrs: {
                        customFieldValue: customFieldValue,
                        filterGroupData: conditions,
                        groupIdx: idx,
                        filterList: this.filterList,
                        updateFilterList: this.updateFilterList,
                        discardFieldOptions: _discardFieldOptions,
                        breakdownListByChannel: breakdownListByChannel,
                        categoryListByPrefix,
                        isElseGroup: isElseGroup,
                        genericLevelOptions: this.genericLevelOptions,
                        genericLevelTranslator: this.genericLevelTranslator,
                        // discardGenericLevelOptions={selectedCategories}
                    },
                    on: {
                        setElseCasePresent: (v) => (this.elseCasePresent = v),
                    },
                };

                return <FilterGroup {...props} />;
            }) ?? [];

        const conditionsDom$ = R.intersperse(
            <S.SpaceHolder />,
            filterGroupsDom$
        );

        return (
            <S.DimensionTypeEditorWrapper>
                <S.DimensionTitleWrapper>
                    <FLEX_DIV> </FLEX_DIV>
                    <FLEX_DIV>
                        <S.ResetButton onClick={this.handleRemoveAll}>
                            {this.$t(
                                'NEW_DASHBOARD.ua_filter_setting_panel_reset'
                            )}
                        </S.ResetButton>
                    </FLEX_DIV>
                </S.DimensionTitleWrapper>
                {conditionsDom$}
                {!this.elseCasePresent && (
                    <S.CommonButtonContainer>
                        <CommonButton
                            type="white"
                            css={S.ApplyAddBtnCss}
                            onClick={this.handleAddFilterGroup}
                        >
                            <PlusIcon v-view-box />
                            <FLEX_CENTER_DIV class={'add-if-else-button'}>
                                IF
                            </FLEX_CENTER_DIV>
                        </CommonButton>
                        <CommonButton
                            type="white"
                            css={S.ApplyAddBtnCss}
                            onClick={this.handleAddFilterGroupElse}
                        >
                            <PlusIcon v-view-box />
                            <FLEX_CENTER_DIV class={'add-if-else-button'}>
                                ELSE
                            </FLEX_CENTER_DIV>
                        </CommonButton>
                    </S.CommonButtonContainer>
                )}
            </S.DimensionTypeEditorWrapper>
        );
    },
};
